export const EXPENSE_TYPE_OPTIONS = [
  { value: 'materials', label: 'Materials' },
  { value: 'equipment_rental', label: 'Equipment / Rental' },
  { value: 'permit_fee', label: 'Permits / Fees' },
  { value: 'disposal', label: 'Disposal / Dump' },
  { value: 'delivery_freight', label: 'Delivery / Freight' },
  { value: 'fuel_travel', label: 'Fuel / Travel' },
  { value: 'tools_consumables', label: 'Tools / Consumables' },
  { value: 'professional_service', label: 'Professional Service' },
  { value: 'reimbursement_credit', label: 'Reimbursement / Refund (money back)' },
  { value: 'other', label: 'Other' },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: 'company_card', label: 'Company Card' },
  { value: 'personal_card', label: 'Personal Card' },
  { value: 'cash', label: 'Cash' },
  { value: 'check', label: 'Check' },
  { value: 'ach', label: 'ACH / Bank Transfer' },
  { value: 'other', label: 'Other' },
];

export const REIMBURSEMENT_OPTIONS = [
  { value: 'not_applicable', label: 'Not Applicable' },
  { value: 'pending', label: 'Pending' },
  { value: 'reimbursed', label: 'Reimbursed' },
];

export const EXPENSE_SORT_OPTIONS = [
  { value: 'date_newest', label: 'Newest Expense Date' },
  { value: 'date_oldest', label: 'Oldest Expense Date' },
  { value: 'amount_high', label: 'Highest Amount' },
  { value: 'amount_low', label: 'Lowest Amount' },
  { value: 'recently_updated', label: 'Recently Updated' },
  { value: 'vendor_az', label: 'Vendor A–Z' },
];

const findLabel = (opts, v) => (opts.find((o) => o.value === v) || {}).label || v;
export const expenseTypeLabel = (v) => findLabel(EXPENSE_TYPE_OPTIONS, v);
export const paymentMethodLabel = (v) => findLabel(PAYMENT_METHOD_OPTIONS, v);
export const reimbursementLabel = (v) => findLabel(REIMBURSEMENT_OPTIONS, v);

export const fmtBytes = (n) => {
  if (n == null) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};
